var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteRegist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.789,
    height: 25.075,
    viewBox: "0 0 25.789 25.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_24",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24",
    transform: "translate(-1760.961 -145.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(1757.711 143.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_4",
    "data-name": "\\u30D1\\u30B9 4",
    d: "M24.578,22.717V20.144A5.144,5.144,0,0,0,19.433,15H9.144A5.144,5.144,0,0,0,4,20.144v2.572",
    transform: "translate(0 3.433)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_4",
    "data-name": "\\u6955\\u5186\\u5F62 4",
    cx: 5,
    cy: 5.5,
    rx: 5,
    ry: 5.5,
    transform: "translate(9.289 2.575)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_37",
    "data-name": "\\u7DDA 37",
    y2: 6,
    transform: "translate(1783 148)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_38",
    "data-name": "\\u7DDA 38",
    x1: 6,
    transform: "translate(1780 151)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRegist);
export default __webpack_public_path__ + "static/media/white_regist.d5ab1e080f4cd216bb9c06d1cf0f9660.svg";
export { ForwardRef as ReactComponent };